// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__3W4A8","inputText":"Form_inputText__3Bo9M","submitButton":"Form_submitButton__3ywVe"};